import { Modal } from 'UIPackage/ModalModule/components/Modal';

import { ModalHeader } from '../../../UIPackage/ModalModule/components/ModalHeader';
import { ModalBody } from '../../../UIPackage/ModalModule/components/ModalBody';
import styles from './AccessDeniedForTestModal.module.scss';

interface IAccessDeniedForTestModalProps {
  visible?: boolean;
}

export const AccessDeniedForTestPlanModal = ({ visible }: IAccessDeniedForTestModalProps) => {
  return (
    <Modal visible={visible} closeButtonClassName={styles.CloseButton}>
      <ModalHeader title="Уведомление об ограничении доступа" />
      <ModalBody size="content">
        <div className={styles.Body}>
          <span className={styles.AttentionIcon}></span>
          <span className={styles.Bold}>Уважаемый пользователь!</span>
          <span>Доступ к сведениям тестового плана мероприятия ограничен.</span>
        </div>
      </ModalBody>
    </Modal>
  );
};
